export const DQL_FIELD_TYPE_BOOLEAN = {
  FALSE: "false",
  TRUE: "true",
};

export const DQL_FIELD_TYPES = {
  BOOLEAN: "boolean",
  DATE: "date",
  NUMBER: "number",
  STRING: "string",
};

export const DQL_LOGICAL_OPERATORS = {
  AND: "and",
  NOT: "not",
  OR: "or",
};

export const DQL_NODE_TYPES = {
  FIELD: "field",
  GROUP: "group",
  LOGICAL: "logical",
  RELATIONAL: "relational",
  VALUE: "value",
};

export const DQL_RELATIONAL_OPERATORS = {
  DISTINCT: "<>",
  EQUAL: ":",
  EXIST: ": *",
  GREATER: ">",
  GREATER_OR_EQUAL: ">:",
  IN: "in",
  LESS: "<",
  LESS_OR_EQUAL: "<:",
};

export const DQL_SPECIAL_CHARACTERS = {
  PARENTHESIS_CLOSE: ")",
  PARENTHESIS_OPEN: "(",
  QUOTE: "'",
  SPACE: " ",
  WILDCARD: "*",
};

export const SEARCH_ENGINES = {
  DQL: "dql",
  PLAIN: "plain",
};
